import { render } from "./annual_Losses.vue?vue&type=template&id=fdfe2966"
import script from "./annual_Losses.vue?vue&type=script&lang=js"
export * from "./annual_Losses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__